module.exports = __webpack_public_path__ + "img/eye-logo.31c91029.svg";